/**
 * Extract a user-facing error message from an unknown API error.
 *
 * The OpenAPI client surfaces structured failures as `{ body: { message } }`,
 * while runtime / network errors land as native Error instances. This helper
 * collapses both shapes (and any unknown rejection value) into a single string,
 * falling back to a caller-supplied default when neither field is present.
 */
export function extractApiError(error: unknown, fallback = 'Something went wrong'): string {
  const e = error as { body?: { message?: string }; message?: string } | undefined
  return e?.body?.message || e?.message || fallback
}
